<div [matTooltip]="showTooltip() ? sentimentTooltip : null">
  @if (sentimentDisplay() === 'polarity') {
    <mat-icon
      fontSet="material-icons-filled"
      [ngClass]="[
        'sentiment-value',
        'sentiment-value--polarity',
        'sentiment-color-' + colorForPolarity,
      ]"
    >
      {{ iconForPolarity }}
    </mat-icon>
  } @else {
    <ng-container [ngTemplateOutlet]="numeric"></ng-container>
  }
  @if (isModified) {
    *
  }
  @if (!isModified) {
    &nbsp;
  }
  <ng-template #numeric>
    <div
      [class]="'sentiment-value sentiment-value--numeric sentiment-color-' + colorForPolarity"
      [class.sentiment-value--modified]="isModified"
    >
      {{
        sentimentScore | roundHalfAway: precision() | number: '1.' + precision() + '-' + precision()
      }}
    </div>
  </ng-template>
</div>
